export default __webpack_public_path__ + "static/glam_night-b648328b90324fdfbb26f368ad302781.png";